module.exports = __webpack_public_path__ + "img/3_x9.90e0fb28.png";